<template>
	<div v-if="attribute" class="cd-energy-info">
		<div class="cd-energy" :class="{'link': energyImage}" @click="(energyImage) ? flyoutEnergy(energyImage) : null">
			<BaseUiImage v-if="attribute.image_upload_path" :src="attribute.image_upload_path" width="70" height="26" default="/images/no-image-50.jpg" :alt="attribute.title" />
			<template v-if="attribute.title && attribute?.energy_image_upload_path != null">{{ attribute.title }}</template>
			<span><BaseCmsLabel code="energy_title" /></span>
		</div>
	</div>
</template>

<script setup>
	const {emit} = useEventBus();
	const labels = useLabels();
	const props = defineProps(['attributeItem', 'energyImage']);

	const attribute = computed(() => {
		const targetAttributeCodes = ['ucinek-pranja-in-su-100218739', 'razred-energijske-u-100215480', 'razred-energijske-u-100176542', 'razred-energij-ucinkov-35'];
		return props.attributeItem?.find(attr => targetAttributeCodes.includes(attr.attribute_code)) || null;
	});

	//flyout content
	function flyoutEnergy(value) {
		emit('flyoutUpdate', {'flyout_mode': 'energy', 'flyout_title': labels.get('energy_flyout_title'), 'flyout_content': value ? value : null});
	}
</script>
